export default __webpack_public_path__ + "static/openarea-04c498946bb45dd7e3be75d2283765d9.jpg";